export const HOME = '/';